import { JourneyStep } from '../types/journey-steps';
import {
  packagesFirstHolidaySearchJourney,
  defaultHolidaySearchJourney,
} from '../data/holidays/journey-steps';
import { defaultCaravanSearchJourney } from '../data/caravans/journey-steps';
import { useUnleash } from '../providers/unleashProvider';
import { Query } from '../types/v2/holiday-search';

export const getHolidaySearchJourney = (packagesFirstJourneyEnabled = false): JourneyStep[] => {
  return packagesFirstJourneyEnabled
    ? packagesFirstHolidaySearchJourney
    : defaultHolidaySearchJourney;
};

export const getCaravanSearchJourney = (): JourneyStep[] => {
  return defaultCaravanSearchJourney;
};

export const useJourneySteps = (
  type: 'holidays' | 'caravans' = 'holidays',
  query?: Query,
): JourneyStep[] => {
  const { isUnleashVariantActiveCsr } = useUnleash();

  const packagesFirstExperiment = query
    ? isUnleashVariantActiveCsr('search-0434-widget', '2', query)
    : false;

  if (type === 'caravans') {
    return getCaravanSearchJourney();
  }

  return getHolidaySearchJourney(packagesFirstExperiment);
};
